  import * as React from 'react';
  import { useState, useEffect, useRef } from 'react';
  import { useParams } from 'react-router-dom';
  import { doc, setDoc, getDoc, updateDoc, arrayUnion } from "firebase/firestore";
  import { useDocumentData } from 'react-firebase-hooks/firestore';
  import { db } from "../lib/firebase";
  import './MessageStyles.css';
  import { Container, Box, Typography, Input, IconButton, useMediaQuery, useTheme } from "@mui/material";
  import 'firebase/firestore';
  import SendIcon from '@mui/icons-material/Send';
  import { themes } from '../lib/theme';
  import calmMusic from '../assets/calm.mp3';
  import MusicPlayer from '../components/musicPlayer';


  // Chat message bubble function
  function ChatMessage(props) {
    const { text, user } = props.message;
    const theme = props.theme;

    const justifyContent = user ? 'flex-end' : 'flex-start';
    const bubbleColor = user ? themes[theme].chatBubbleColor2 : themes[theme].chatBubbleColor;
    const textColor = user ? themes[theme].chatTextColor : themes[theme].chatTextColor2;
    const bubbleStyling = user ? themes[theme].chatBubbleStyling : themes[theme].chatBubbleStyling2;
    
    return (
      <Box 
        sx={{
          width: '100%',
          display: 'flex', 
          justifyContent: justifyContent,
          transition: 'background-color 0.3s ease, color 0.3s ease',
        }}
      >
        <Box 
          className="chat-bubble"
          sx={{
            backgroundColor: bubbleColor,
            maxWidth: '40%',  // Set maxWidth here for the bubble
            ...bubbleStyling,
            transition: 'background-color 0.3s ease',
            padding: '8px 16px', // Optional: Add some padding for better appearance
            borderRadius: '16px', // Optional: Add border-radius for a bubble effect
          }}
        >
          <Typography 
            className="chat-bubble-text" 
            sx={{
              color: textColor,
              transition: 'color 0.3s ease',
              wordWrap: 'break-word' // Ensure long words break properly
            }}
          >
            {text}
          </Typography> 
        </Box>
      </Box>
    );
  }


  // import { useMediaQuery, useTheme } from "@mui/material";

  // Main chatroom
  function Chatroom() {
    const themeObj = useTheme(); // Get the current theme object
    const isMobile = useMediaQuery(themeObj.breakpoints.down('sm')); // Determine if the screen size is 'sm' or below
  
    //// Scroll functionality
    const messagesEndRef = useRef(null);
  
    const scrollToBottom = () => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };
  
    //// Colour theme functionality
    const [theme, setTheme] = useState('dark');
    const themeList = ['light', 'dark', 'campfire'];
  
    useEffect(() => {
      const savedTheme = localStorage.getItem('theme') || 'light';
      setTheme(savedTheme);
    }, []);
  
    // Toggle theme and save preference
    const toggleTheme = () => {
      const currentIndex = themeList.indexOf(theme);
      const nextIndex = (currentIndex + 1) % themeList.length;
      const newTheme = themeList[nextIndex];
      setTheme(newTheme);
      localStorage.setItem('theme', newTheme);
    };
  
    const ThemeIcon = themes[theme].icon;
  
    //// Message functionality
    const [currentMessage, setCurrentMessage] = useState("");
    let { id } = useParams();
    const document = doc(db, 'rooms/' + id);
    const [data, loading, error] = useDocumentData(document);
  
    const handleMessageSend = async (e) => {
      e.preventDefault();
      if (currentMessage.length > 0) {
        await updateDoc(doc(db, "rooms", id), {
          messages: arrayUnion({
            text: currentMessage,
            createdAt: new Date(),
            user: true
          }),
          lastSent: new Date(),
          lastSentUser: true, 
        });
        e.target.reset();
        setCurrentMessage("");
      }
    };
  
    useEffect(() => {
      scrollToBottom();
    }, [data]);
  
    return (
      <Box
        sx={{
          backgroundColor: themes[theme].backgroundColor, 
          height: '100vh', 
          justifyContent: "space-between",
          minWidth: '100vw',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row', // Change direction based on screen size
          alignItems: 'end',
          overflow: 'hidden',
          backgroundImage: themes[theme].bg,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom center',
          zIndex: -1,
          transition: 'background-color 0.3s ease, background-image 0.3s ease, opacity 0.3s ease',
          opacity: 1
        }}
      >
        <Container 
          className="messageArea" 
          sx={{
            height: "90vh",
            width: isMobile ? '100vw' : '75vw', // Full width for mobile, 75% for larger screens
            backgroundColor: themes[theme].chatBoxColor,
            py: 1.5,   
            m: 0,
            display: 'flex',
            flexDirection: 'column',
            borderRadius: isMobile ? 0 : '10px', // No border-radius on mobile
            ml: isMobile ? 0 : 3, 
            mb: isMobile ? 0 : 4,
            pl: '10px !important',
            pr: '0 !important',
            ...themes[theme].chatBoxStyling,
            transition: 'background-color 0.3s ease, opacity 1s ease',
            opacity: 1
          }}
        >
          <Box
            sx={{
              position: 'fixed',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start'
            }}
          > 
            <IconButton
              onClick={toggleTheme}
              sx={{
                maxWidth: '50px',
                transition: 'opacity 0.3s ease',
                opacity: 1,
              }}
            >
              <ThemeIcon 
                sx={{ 
                  color: themes[theme].buttonColor, 
                  transition: 'color 0.3s ease, opacity 0.3s ease', 
                  opacity: 1,
                }}
              />
            </IconButton> 
            <MusicPlayer 
              calmMusic={calmMusic} 
              theme={theme} 
            />
          </Box>
          <Box 
            sx={{
              flexGrow: 1,
              mr: '26px !important',
              mt: '26px',
              ml: '16px',
              transition: 'opacity 0.3s ease',
              opacity: 1
            }}
          >
            {loading ? (
              <Typography> LOADINGGGG </Typography>
            ) : ( 
              data.messages.map((msg, index) => (
                <ChatMessage key={index} message={msg} theme={theme} />
            )))}
            <div ref={messagesEndRef} />
          </Box>
          <form onSubmit={handleMessageSend} style={{ width: '100%' }}>
            <Box 
              sx={{
                display: 'flex', 
                justifyContent: "space-between", 
                flexDirection: "row",
                minWidth: '100%',
                transition: 'opacity 0.3s ease',
                opacity: 1
              }}
            >
              <Input 
                disableUnderline 
                type="text"  
                onChange={(e) => setCurrentMessage(e.target.value)} 
                sx={{
                  backgroundColor: themes[theme].inputColor,
                  flexGrow: 1,
                  borderRadius: '40px',
                  paddingLeft: "10px",
                  '& .MuiInputBase-input': {
                    color: '#caccd0',
                  },
                  transition: 'background-color 0.3s ease, opacity 0.3s ease',
                  opacity: 1,
                  ...themes[theme].inputStyling
                  
                }}
              />
              <IconButton type="submit" color="primary">
                <SendIcon 
                  sx={{ 
                    color: themes[theme].buttonColor, 
                    transition: 'color 0.3s ease, opacity 0.3s ease', 
                    opacity: 1 
                  }} 
                />
              </IconButton>
            </Box> 
          </form>
        </Container>
        {!isMobile && ( // Hide this Box on mobile devices
          <Box
            sx={{
              minHeight: '100%',   
              display:  'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '25%',
              transition: 'opacity 0.3s ease',
              opacity: 1,
            }}
            id='interactive-box'
          />
        )}
      </Box>
    );
  }
  export default Chatroom;
  
